var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPitest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "11_\u76AE\u8BD5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30,12V8H24.07A2.07,2.07,0,0,1,22,6a2,2,0,0,1,2-2H39.86A2.07,2.07,0,0,1,42,6a2,2,0,0,1-2,2H34v4H47.9A2.07,2.07,0,0,1,50,14a2,2,0,0,1-2,2H44V44.35a10,10,0,0,1-5.94,9.14l-4.49,2h0L33.24,59a1.21,1.21,0,0,1-1.36,1,1.25,1.25,0,0,1-1.11-.93l-.34-3.56h0l-4.49-2A10,10,0,0,1,20,44.38V16H16.11a2.06,2.06,0,0,1-2.1-2A2,2,0,0,1,16,12l14,0S30,12,30,12Zm4,4v1.9A2.08,2.08,0,0,1,32,20a2,2,0,0,1-2-2V16H24v6H40V16H34Zm6,10H24V44.38A6.2,6.2,0,0,0,27.52,50h0L32,52.48h0L36.55,50h0A6.05,6.05,0,0,0,40,44.38V26Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitest);
export default __webpack_public_path__ + "static/media/pitest.0e8bab55.svg";
export { ForwardRef as ReactComponent };